import MethodActionGenerator from './MethodActionGenerator'

export default class CreateActionGenerator extends MethodActionGenerator {
  constructor(name, basePath, parameterName) {
    super('CREATE', name, basePath, parameterName)
  }

  mainActionGenerator = () => {
    return (attributes, urlParams) => (dispatch) => {
      dispatch({ type: this.types.request, attributes })

      return this.client.post(this.urlWithParams(urlParams), { [this.parameterName]: attributes })
        .then((response) => {
          return dispatch({
            type: this.types.response,
            id: response.data.id,
            responseAttributes: response.data,
            responseHeaders: response.headers
          })
        })
        .catch((error) => dispatch({ type: this.types.error, ...this.parseError(error) }))
    }
  }
}
